import React from "react";
import Button from "./../common/Button";

function ProfileSection() {
  return (
    <section className="flex flex-wrap gap-6 items-end w-full font-medium max-md:max-w-full">
      <div className="flex-1 shrink text-lg leading-loose text-gray-700 basis-0 min-w-60 max-md:max-w-full">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/eb226542e6a54a1c8fe305b1d38613f0/aadfc68e383661cbbbf2ba5afba58c3e5b1d6c2c7e08c2bacb8f68687052aafe?placeholderIfAbsent=true"
          alt="Profile picture"
          className="object-contain w-16 aspect-square rounded-[640px]"
        />
        <h2 className="mt-4 max-md:max-w-full">Profile picture</h2>
      </div>
      <div className="flex gap-3 items-end text-sm leading-loose">
        <Button primary icon="export">
          upload a photo
        </Button>
        <Button neutral>Delete</Button>
      </div>
    </section>
  );
}

export default ProfileSection;
